import type { ElementRef } from '../lib/teact/teact';
import { useEffect } from '../lib/teact/teact';

import styles from '../components/ui/Menu.module.scss';

// This effect implements closing menus by interacting outside of them
// without adding extra elements to the DOM
export default function useVirtualBackdrop(
  isOpen: boolean,
  menuRef: ElementRef<HTMLDivElement>,
  onClose?: () => void | undefined,
) {
  useEffect(() => {
    const handleEvent = (e: Event) => {
      const menu = menuRef.current;
      const target = e.target as HTMLElement | null;
      if (!menu || !target) {
        return;
      }

      if (
        !menu.contains(e.target as Node | null)
        || target.classList.contains(styles.backdrop)
      ) {
        // A touch may become a scroll gesture. Closing must not interrupt that gesture.
        if (e.type === 'mousedown') {
          e.preventDefault();
          e.stopPropagation();
        }
        if (onClose) {
          onClose();
        }
      }
    };

    if (isOpen && onClose) {
      document.addEventListener('mousedown', handleEvent);
      document.addEventListener('touchstart', handleEvent);
    }

    return () => {
      document.removeEventListener('mousedown', handleEvent);
      document.removeEventListener('touchstart', handleEvent);
    };
  }, [isOpen, menuRef, onClose]);
}
